import setTitleCase from './setTitleCase';
/**
 * Splits string on separator, filters out null/empty values, title-cases each part,
 * and joins on spacer. Trims leading/trailing whitespace first so extra spacers
 * (e.g. trailing "-" or " ") are not produced from padded input.
 * Default: ex jOhn SMITH => John Smith
 *
 * @param {object} opts
 * @param {string} opts.name - Value to format; trimmed before split
 * @param {string} opts.defaultValue - Fallback when name is missing/empty
 * @param {string|null} [opts.spacer] - Join string between parts (default: space)
 * @param {string|null} [opts.separator] - Split delimiter (default: space)
 * @returns {string}
 */
const formatNameCaseWithSplitterAndSpacer = (opts = {}) => {
  if (!opts || !opts.name || opts.name === '') {
    return opts?.defaultValue ?? '';
  }

  const spacer = opts.spacer ?? ' ';
  const separator = opts.separator ?? ' ';

  return opts.name
    .trim()
    .split(separator)
    .filter(x => x !== 'null' && x !== '')
    .map(function(item) {
      return setTitleCase({ text: item });
    })
    .join(spacer);
};

export default formatNameCaseWithSplitterAndSpacer;
